import TTLCache from '@isaacs/ttlcache';
export { TTLCache as TtlCache };